/**
 * The S3 key behind a download link. Presigned links to the same object differ in query string on
 * every regeneration (and can differ in host after a bucket move), so compare objects by this.
 */
/** Whether a link points at one of our buckets in any AWS S3 form; mirrors the backend's ``is_our_s3_bucket_url``. */
export const isOurBucketLink = (url, buckets) => {
    let parsed;
    try {
        parsed = new URL(url);
    }
    catch {
        return false;
    }
    const host = parsed.hostname.toLowerCase();
    if (parsed.protocol !== "https:" || !host.endsWith(".amazonaws.com"))
        return false;
    const names = buckets.map((bucket) => bucket.toLowerCase());
    const [first, second = ""] = host.split(".");
    if (names.includes(first) && (second === "s3" || second.startsWith("s3-")))
        return true;
    if (first !== "s3" && !first.startsWith("s3-"))
        return false;
    return names.includes(parsed.pathname.replace(/^\//, "").split("/")[0].toLowerCase());
};
export const s3KeyOf = (url) => {
    try {
        return decodeURIComponent(new URL(url).pathname);
    }
    catch {
        return url;
    }
};
